import { getAdjustedDirection, getClipPolygonParams } from '../../utils';
export { initialFrame } from './common';
const DIRECTIONS = ['top', 'right', 'bottom', 'left'];
function getClipStart(rotateZ, direction) {
  const clipDirection = getAdjustedDirection(DIRECTIONS, direction, rotateZ);
  return getClipPolygonParams({
    direction: clipDirection,
    minimum: 0
  });
}
export function web(options, dom) {
  const [{
    custom,
    ...revealIn
  }] = style(options);
  prepare(options, dom);
  return [{
    ...revealIn,
    keyframes: [{
      clipPath: `var(--motion-clip-path, ${custom['--motion-clip-start']})`
    }, {
      clipPath: custom['--motion-clip-end']
    }]
  }];
}
export function style(options) {
  const {
    direction = 'left'
  } = options.namedEffect;
  const easing = options.easing || 'cubicInOut';
  const start = getClipStart(0, direction);
  const end = getClipPolygonParams({
    direction: 'initial'
  });
  return [{
    ...options,
    easing,
    name: 'revealIn',
    custom: {
      '--motion-clip-start': start,
      '--motion-clip-end': end
    }
  }];
}
export function prepare(options, dom) {
  const {
    direction = 'left'
  } = options.namedEffect;
  if (dom) {
    dom.measure(target => {
      if (!target) {
        return;
      }
      const rotation = getComputedStyle(target).getPropertyValue('--comp-rotate-z') || '0deg';
      dom.mutate(target_ => {
        target_ == null || target_.style.setProperty('--motion-clip-start', getClipStart(parseInt(rotation, 10), direction));
      });
    });
  }
}
//# sourceMappingURL=RevealIn.js.map